import React, { Component, useState } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { View, Text, Image, ActivityIndicator} from "react-native-web";

import HamburgerMenu from 'react-hamburger-menu';

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function FooterMobile(props) {
  const currentYear = new Date().getFullYear();
  const [open, setOpen] = useState(false);
   const navigate = useNavigate();

   const location = useLocation();

   let pathname = location.pathname;


   const handleClick = () => {
       let bool = !open;
       setOpen(bool);

       props.handleMenuClick(bool);
   }

    return (

      <div style={{backgroundColor: 'transparent'}}>

         <div style={{height: '100px'}}/>

         {i18n.language == 'en' &&
            <div style={{width: '94%', margin: 'auto', fontSize: '16px', fontFamily: 'Roboto', paddingTop: '20px', textAlign: 'center', borderTop: '1px solid #ccc'}}>
                <div>© {currentYear} · StorryPage, a product of <a href="https://www.debyoo.com" target="_blank">Debyoo</a></div>
                <div style={{marginTop: '6px'}}><a href="/about">{i18n.t('About')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/get-a-storrypage">{i18n.t('Get_a_storrypage')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/living-memory-of-congo">{i18n.t('Living_memory_of_congo')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/help">{i18n.t('Help_center')}</a></div>
           </div>
         }

         {i18n.language == 'fr' &&
            <div style={{width: '94%', margin: 'auto', fontSize: '16px', fontFamily: 'Roboto', paddingTop: '20px', textAlign: 'center', borderTop: '1px solid #ccc'}}>
                <div>© {currentYear} · StorryPage, un produit de <a href="https://www.debyoo.com" target="_blank">Debyoo</a></div>
                <div style={{marginTop: '6px'}}><a href="/about">{i18n.t('About')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/get-a-storrypage">{i18n.t('Get_a_storrypage')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/memoire-vivante-du-congo">{i18n.t('Living_memory_of_congo')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/help">{i18n.t('Help_center')}</a></div>

                <div style={{display: 'none', marginTop: '6px'}}><a href="/help" style={{color: '#5800d9'}}>Aide</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/privacy" style={{color: '#5800d9'}}>Confidentialité</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/terms" style={{color: '#5800d9'}}>Termes d'utilisation</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="https://www.debyoo.com/contact" target="_blank" style={{color: '#5800d9'}}>Contact</a></div>
           </div>
         }

         <div style={{height: '30px'}}/>

      </div>

    )

}
